<template>
  <b-modal
    v-model="modal"
    title="Move"
    ok-title="Move"
    cancel-variant="bg-white"
    body-class="p-0 position-relative"
    centered
    :ok-disabled="!!!selectedObject"
    @hidden="
      () => {
        $emit('close')
      }
    "
    @ok.prevent="move"
  >
    <available-directories
      v-if="!enterManually"
      v-model="selectedObject"
      :objects-to-move="objectsToMove"
      :parents="parents"
      :account-id="accountId"
    />
    <div
      v-else
      class="px-1 pt-2"
    >
      <input-field
        name="path"
        label="Move to"
        label-position="top"
        info-position="label"
      >
        <b-input
          id="path"
          ref="manualPathInput"
          v-model="manualPathInput"
          type="text"
          placeholder="Enter path here..."
        />
      </input-field>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <div class="d-flex justify-content-between w-100 align-items-center">
        <a
          class="text-primary"
          @click="enterManually = !enterManually"
        >{{
          !enterManually ? 'Enter Path' : 'Select from list'
        }}</a>
        <div class="d-flex">
          <b-button
            size="sm"
            variant="bg-white"
            @click="cancel()"
          >
            Cancel
          </b-button>
          <b-button
            size="sm"
            variant="primary"
            class="ml-1"
            :disabled="(checkIfPathSelected() || updatingObject)"
            @click="ok()"
          >
            Move
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import StorageHelpers from '@/mixins/storage-helpers'
import InputField from '@/components/form/InputField.vue'
import AvailableDirectories from './AvailableDirectories.vue'

export default {
  name: 'MoveObject',
  components: {
    AvailableDirectories,
    InputField,
  },
  mixins: [StorageHelpers],
  props: {
    activeKey: {
      default: '',
      type: String,
    },
    objectsToMove: {
      type: Array,
      default: null,
    },
    parents: {
      type: Array,
      default: null,
    },
    accountId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      modal: false,
      selectedObject: null,
      enterManually: false,
      manualPathInput: '',
    }
  },
  computed: {
    bucketName() {
      return this.$route.params.id
    },
    updatingObject() {
      return this.$store.state.accountObjects.updatingObject
    },
  },
  watch: {
    activeKey(val) {
      this.manualPathInput = val
    },
    objectsToMove(val) {
      this.modal = !!val
    },
    modal(val) {
      if (!val) {
        this.selectedObject = null
      } else {
        this.enterManually = false
      }
    },
  },
  created() {
    this.modal = !!this.objectsToMove
    this.manualPathInput = this.activeKey
  },
  methods: {
    checkIfPathSelected() {
      if (this.enterManually) {
        return this.manualPathInput === '' || this.manualPathInput === this.activeKey
      }

      return !this.selectedObject
    },
    move() {
      const updateObj = {
        prefixes: {},
        keys: {},
      }
      let to
      if (this.enterManually) {
        const hasSlash = this.manualPathInput
          ? this.manualPathInput.substr(-1) === '/'
          : true
        to = `${this.manualPathInput}${hasSlash ? '' : '/'}`
      } else {
        to = this.selectedObject.key
      }
      to = to.endsWith('/') ? to : `${to}/`
      this.objectsToMove.forEach(obj => {
        if (obj.isFolder) {
          updateObj.prefixes[obj.key] = `${to
            + this.formatObjectName(obj.key)}/`
        } else {
          updateObj.keys[obj.key] = to + this.formatObjectName(obj.key)
        }
      })
      this.$store
        .dispatch('accountObjects/updateObjectKeys', {
          accountId: this.accountId,
          query: {
            bucketName: this.bucketName,
            updateObj,
          },
        })
        .then(() => {
          this.successToast('File(s)/Folder(s) moved successfully.')
          this.$store
            .dispatch('accountObjects/refreshUntilStatusCleared', { accountId: this.accountId })
            .catch(() => {})
          this.reset()
        })
        .catch(() => {
          this.errorToast('Error moving files.')
          this.reset()
        })
    },
    reset() {
      this.modal = false
    },
  },
}
</script>
